import React, { Component } from "react";
import "styles/CustomRadio.scss";

export default class CustomRadio extends Component {
  render() {
    const { label, selected, clickRadio } = this.props;
    return (
      <div className="custom-radio" onClick={clickRadio}>
        <div className="custom-radio-button">
          <div
            className={
              "custom-radio-button-inner" + (selected ? "-selected" : "")
            }
          />
        </div>
        <span className="custom-radio-label">{label}</span>
      </div>
    );
  }
}
